// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"6b721e43","644":"3b754c55"}[chunkId] + ".chunk.js";
};